import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

const AdminRoleEditHeader = ({
  roleId,
}) => {
  const intl = useIntl();

  return (
    <header className="page-header">
      <h3>
        {roleId ?
          intl.formatMessage({ defaultMessage: 'Edit Custom Role' }) :
          intl.formatMessage({ defaultMessage: 'New Custom Role' })}
      </h3>
    </header>
  );
};

AdminRoleEditHeader.propTypes = {
  roleId: PropTypes.string,
};

AdminRoleEditHeader.defaultProps = {
  roleId: null,
};

export default AdminRoleEditHeader;
